module.exports = __webpack_public_path__ + "img/in-partnership.a2e01ae.png";